import { Duration } from "@/Temporal"
import { RouterView } from "vue-router"
import { defineComponent, loadLoadable, type ReactiveComponent } from "vue-utils"
import { BasicErrorPage } from "./components/loading/BasicErrorPage"
import { ContentLoading } from "./components/loading/StateLoading"
import { useStoreRefresh } from "./composition/useStoreRefresh"
import BasicPage from "./pages/BasicPage"
import { useAppConfig } from "./stores/appConfigStore"
import { useCoreDataStore } from "./stores/coreDataStore"

const MainApp: ReactiveComponent = () => {
	const config = useAppConfig()
	const coreDataStore = useCoreDataStore()
	useStoreRefresh({ coreData: coreDataStore }, Duration.from({ hours: 1 }))

	return () => {
		switch (coreDataStore.type) {
			case "done":
				return <RouterView />
			case "error":
				return (
					<BasicPage title={config.appName} noNav>
						<BasicErrorPage
							error={coreDataStore.error}
							reload={async () => {
								await loadLoadable(coreDataStore)
							}}
						/>
					</BasicPage>
				)
		}
		return <ContentLoading stores={[coreDataStore]} />
	}
}

export default defineComponent(MainApp)
